import { Meteor } from 'meteor/meteor';
import React from 'react';
import { moment } from 'moment';

import { ReservationModal } from './ReservationModal';
import { FlightTypeColor } from './flightTypeColorComponent';

import {
	Icon,
	Table,
	Checkbox
} from '@sketchpixy/rubix';

import { Reactive } from '../../common/Reactive.mixin.js';

export class ReservationTable extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			modal: {
				visible: false,
				reservation: null
			}
		};
	}

	openModal(reservation) {
		this.setState({
			modal: {
				visible: true,
				reservation: reservation
			}
		});
	}

	handleCheckboxChange(e, reservation) {
		const value = e.target.checked;

		if (value)
			this.props.selected.set(reservation._id, reservation);
		else
			this.props.selected.delete(reservation._id);

		console.log('type', reservation.getFlightType());

		this.forceUpdate();
	}

	render() {
		return (
			<div style={{'overflow':'scroll'}}>
				<Table striped bordered condensed hover>
					<thead>
						<tr>
							<th>#</th>
							<th>Type</th>
							<th>Billet</th>
							<th>Passagers</th>
							<th>Poids</th>
							<th>Liaison ?</th>
							<th>Infos</th>
						</tr>
					</thead>
					<tbody>
						{this.props.reservations
							&& this.props.reservations.map((reservation) => {
								return (
									<tr>
										<td><Checkbox checked={this.props.selected.has(reservation._id)} onChange={(e) => this.handleCheckboxChange(e, reservation)}></Checkbox></td>
										<td><div className="flight-type-color" style={{backgroundColor: reservation.color}}>&nbsp;</div></td>
										<td>N°{reservation.id_billet}</td>
										<td>{reservation.passengers.length} pax</td>
										<td>{reservation.totalWeight()}Kg</td>
										<td>{reservation.linkReservation}</td>
										<td><Icon glyph="glyphicon-search" onClick={() => this.openModal(reservation)}/></td>
									</tr>
								);
							})
						}
					</tbody>
				</Table>

				<ReservationModal visible={this.state.modal.visible} reservation={this.state.modal.reservation} onHide={() => this.setState({ modal: { visible: false }})} />
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/reservations/components/ReservationTable.js
 **/